import { FC, useEffect } from 'react';
// i18next
import { useTranslation } from 'react-i18next';
// Redux
import { useAppDispatch } from 'app/hooks/useStore';
// Async
import { getCurrentStats, getCurrentMonthlyStats } from 'app/store/Analytics/Analytics.async';
// Mui
import { Container, Divider, Paper } from '@mui/material';
// Components
import { AnalyticsStats, AnalyticsMonthlyStats } from 'app/components/Analytics';
// Mixpanel
import MixpanelActions from 'app/features/mixpanel/MixpanelActions';

const UsageReportTabContent:FC = () => {
  const { t } = useTranslation();
  // Dispatch
  const dispatch = useAppDispatch();

  const handleGetStats = () => {
    dispatch(getCurrentStats({}));
  }

  const handleGetMonthlyStats = (params:any) => {
    dispatch(getCurrentMonthlyStats(params));
  }

  useEffect(() => {
    dispatch(MixpanelActions.handleUsageReportView());
    // eslint-disable-next-line
  }, []);

  return (
    <Container sx={{ pt: 4, pb: 4 }} maxWidth="md">
      <Paper sx={{ p: 4 }}>
        <AnalyticsStats
          title={t('labels.accountSummary')}
          onGetStats={handleGetStats}
        />
        <Divider sx={{ my: 4 }} />
        <AnalyticsMonthlyStats
          title={t('labels.selectedRangeSummary')}
          onGetMonthlyStats={handleGetMonthlyStats}
        />
      </Paper>
    </Container>
  )
}

export default UsageReportTabContent